import React, { memo } from "react";
import { Stack } from "investira.react.components";
import { HighchartsReact } from "investira.react.charts";
import { ATIVO_MERCADO, ATIVO_TIPO } from "@investirapri/financa.js/lib/enums";
import { formats } from "investira.sdk";

const AtivosChart = memo((props) => {
  const { data = [] } = props;

  const processData = (data) => {
    const xData = Object.values(data);
    const xTotal = xData.reduce((sum, item) => sum + item.financeiro, 0);

    const xThreshold = xTotal * 0.01; // 1% do total
    const xMainData = {};

    let xOthersSumFinanceiro = 0;
    let xOthersSumAtivos = 0;

    Object.entries(data).forEach(([xKey, xItem]) => {
      if (xItem.financeiro >= xThreshold) {
        xMainData[xKey] = xItem;
      } else {
        xOthersSumFinanceiro += xItem.financeiro;
        xOthersSumAtivos += xItem.quantidade_ativos;
      }
    });

    if (xOthersSumFinanceiro > 0) {
      xMainData.OUTROS = {
        financeiro: xOthersSumFinanceiro,
        quantidade_ativos: xOthersSumAtivos,
      };
    }

    return xMainData;
  };

  const reduceData = (pData = [], pGroupBy = "mercado") => {
    let xGrouped = pData.reduce((xAcc, xItem) => {
      const xKey = xItem[pGroupBy];

      if (!xAcc[xKey]) {
        xAcc[xKey] = {
          financeiro: 0,
          quantidade_ativos: 0,
        };
      }

      xAcc[xKey].financeiro += xItem.financeiro;
      xAcc[xKey].quantidade_ativos += xItem.quantidade_ativos;

      return xAcc;
    }, {});

    xGrouped = processData(xGrouped);

    const xResult = Object.entries(xGrouped).map(([xKey, xValue]) => {
      const xKeys = Object.keys(xGrouped).filter((key) => key !== "OUTROS");

      if (xKey === "OUTROS") {
        return {
          name: "Outros",
          y: xValue.financeiro,
          dataLabels: {
            color: "#FFFFFF", // Set the color of data labels to red
          },
          drilldown: xKey,
          metadata: {
            quantidade_ativos: xValue.quantidade_ativos,
            financeiro: formats.formatNumber(xValue.financeiro, 2, true, true),
            ativos: pData
              .filter((xItem) => !xKeys.includes(xItem[pGroupBy]))
              .map((xItem) => xItem),
          },
        };
      }

      return {
        name: ATIVO_MERCADO[xKey].descricao,
        y: xValue.financeiro,
        drilldown: xKey,
        dataLabels: {
          color: "#FFFFFF", // Set the color of data labels to red
        },
        metadata: {
          quantidade_ativos: xValue.quantidade_ativos,
          financeiro: formats.formatNumber(xValue.financeiro, 2, true, true),
          ativos: pData
            .filter((xItem) => xItem[pGroupBy] === xKey)
            .map((xItem) => xItem),
        },
      };
    });
    return xResult;
  };

  const ativoTipoData = (pData) => {
    return pData.map((xItem) => {
      return {
        id: xItem.drilldown,
        name: xItem.name,
        data: xItem.metadata.ativos.map((xAtivo) => {
          return {
            name: ATIVO_TIPO[xAtivo.ativo_tipo_id].descricao,
            y: xAtivo.financeiro,
            metadata: {
              financeiro: formats.formatNumber(
                xAtivo.financeiro,
                2,
                true,
                true
              ),
              quantidade_ativos: xAtivo.quantidade_ativos,
            },
          };
        }),
      };
    });
  };

  const xMercado = reduceData(data, "mercado");
  const xAtivosTipo = ativoTipoData(xMercado);

  const xOptions = {
    chart: {
      type: "pie",
    },
    title: false,
    plotOptions: {
      pie: {
        innerSize: "50%",
        borderColor: "#2e2e46", // Cor do contorno (borda)
        borderWidth: 2, // Largura do contorno
        shadow: false,
        center: ["50%", "50%"],
        dataLabels: {
          enabled: true,
          //useHTML: true,
          // formatter: function () {
          //   return `<span style="color: #FFFFFF; text-decoration: none;">${this.point.name}</span>`;
          // },
          style: {
            color: "#FFFFFF",
            textOutline: "none",
            zIndex: 1,
          },
        },
      },
    },
    tooltip: {
      useHTML: true,
      style: {
        zIndex: 1000, // Set a high z-index for the tooltip
      },
      pointFormat: `Financeiro: <b>{point.metadata.financeiro}</b><br>Quantidade de Ativos: <b>{point.metadata.quantidade_ativos}</b>`,
    },
    series: [
      {
        name: "Mercado",
        colorByPoint: true,
        data: xMercado,
      },
    ],
    drilldown: {
      series: xAtivosTipo,
      breadcrumbs: {
        style: {
          color: "#FFFFFF",
          fill: "#FFFFFF", // Text color
        },
        buttonTheme: {
          style: {
            color: "#00dfa8", // Text color
          },
          states: {
            hover: {
              fill: "none", // Cor de fundo ao passar o mouse
            },
            select: {
              style: {
                color: "#FFFFFF",
                cursor: "default", // Cor do texto quando selecionado
              },
              fill: "none",
            },
          },
        },
      },
    },
  };

  return (
    <Stack flexGrow={0}>
      <HighchartsReact options={xOptions} drilldown />
    </Stack>
  );
});

export default AtivosChart;
